
import { useOnlineStatus } from "@/hooks/use-online-status";
import { WifiOff, Wifi } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const NetworkStatus = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return (
      <div className="flex items-center gap-2 text-sm text-green-600 p-2">
        <Wifi className="h-4 w-4" />
        <span className="sr-only">Online</span>
      </div>
    );
  }

  return (
    <Alert variant="destructive" className="mb-4">
      <WifiOff className="h-4 w-4" />
      <AlertTitle>Offline tilstand</AlertTitle>
      <AlertDescription>
        Du er offline lige nu. Dine ændringer vil blive synkroniseret når du får forbindelse igen.
      </AlertDescription>
    </Alert>
  );
};
